import { FunctionUseDebounce } from "radium-omnibus";
import React, { lazy } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BottomBar } from "../../../components/bar/Bottom.Bar";
import FieldSearchLocation from "../../../components/field/FieldSearchLocation";
import Container from "../../../components/layouts/Container";
import { ContextLanguage } from "../../../context/Context.Language";

import {
  TEXT_ADDRESS_DATA_NOTFOUND,
  TEXT_ADDRESS_SEARCH,
  TEXT_CHOOSE_ADDRESS,
} from "../../../utils/useConstants";
import { STATE_CONSTANTS_ADDRESS } from "../../../utils/useConstantState";
import {
  ICON_ADDRESS_LOCATION,
  ICON_CHEVRON_LEFT,
  ICON_EMPTY_ADDRESS,
  ICON_LOCATION,
  ICON_STAR,
  ICON_STAR_OUTLINE,
} from "../../../utils/useIcons";
import {
  StoreDetailAddress,
  StoreSearch,
  StoreSelectedLocation,
} from "../../../utils/useStorage";
import {
  STYLE_ADDRESS_FOUND,
  STYLE_ADDRESS_ICON_BLUE_CIRCLE,
  STYLE_BUTTON_ICON_LEFT,
  STYLE_HEIGHT_BAR,
  STYLE_IMG_EMPTY,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_MIN_H_FULL,
  STYLE_PADDING_NO_MB,
  STYLE_PARENT_ADDRESS,
  STYLE_PROGRAM_BACK,
  STYLE_SCREEN_FULL,
  STYLE_SCREEN_FULL_WITH_FOOTER,
  STYLE_SEARCH_ADDRESS,
  STYLE_SEARCH_ADDRESS_ICON,
  STYLE_SUB_DETAIL,
  STYLE_TEXT_SMS,
} from "../../../utils/useStyle";
import AddressFunctionSearchLocation from "../functions/Address.FunctionSearchLocation";

import AddressGetLatLngOnSelected from "../functions/Address.GetLatLngOnSlected";
import AddressOnClickCurrentLocation from "../functions/Address.OnClickCurrentLocation";
import AddressEmpty from "./Address.Empty";

export const Favorite = ({
  location,
  isStar = false,
  setIsStar,
  setSelecte,
  setTab,
}) => {
  const setSelectedLocation = StoreSelectedLocation(
    (state) => state.setSelectedLocation
  );
  const selectedLocation = StoreSelectedLocation(
    (state) => state.selectedLocation
  );

  const { user } = useSelector((state) => state.auth);

  const isMyLocation = user?.address?.some(
    (address) => address.reference === selectedLocation.reference
  );

  const detailAddress = StoreDetailAddress((state) => state.detailAddress);
  const setDetailAddress = StoreDetailAddress(
    (state) => state.setDetailAddress
  );

  // console.log("location", { location, isMyLocation, selectedLocation });

  if (isMyLocation) {
    return <ICON_STAR className=" w-5  " />;
  } else {
    return (
      <React.Fragment>
        {isStar ? (
          <ICON_STAR
            className=" w-5  cursor-pointer"
            onClick={(e) => {
              if (setIsStar) {
                setIsStar(false);
              }
            }}
          />
        ) : (
          <ICON_STAR_OUTLINE
            className=" w-5  cursor-pointer"
            onClick={(e) => {
              if (setIsStar) {
                setDetailAddress("");

                setIsStar(!isStar);

                AddressGetLatLngOnSelected(setSelectedLocation, location);
              }
            }}
          />
        )}
      </React.Fragment>
    );
  }
};

export const AddressLocation = ({
  setSelecte,
  setTab,
  location,
  isStar = false,
  setIsStar = () => {},
  locationData,
  setHistory,
  index,
}) => {
  const lineRef = React.useRef(null);

  const { language } = React.useContext(ContextLanguage);

  const setSelectedLocation = StoreSelectedLocation(
    (state) => state.setSelectedLocation
  );

  React.useEffect(() => {
    if (lineRef?.current) {
      lineRef.current.style.width = `${lineRef.current.offsetWidth + 48}px`;
    }
  }, []);
  // const { language } = React.useContext(ContextLanguage);
  const { user } = useSelector((state) => state.auth);
  return (
    <div
      className={`relative flex justify-between  h-19 md:h-20 cursor-pointer md:pr-[4px] gap-3.5 c2 `}
    >
      <div
        onClick={(e) => {
          e.stopPropagation();
          // RouterGetHistory(setHistory, STATE_CONSTANTS_ADDRESS.SELECT);
          AddressGetLatLngOnSelected(setSelectedLocation, location);
          setTab(STATE_CONSTANTS_ADDRESS.FOUND);
        }}
        className={`w-full flex gap-[14px] md:gap-3 items-center group h-fit my-auto`}
      >
        <ICON_ADDRESS_LOCATION className={STYLE_ADDRESS_ICON_BLUE_CIRCLE} />
        {/* <div
          className={` ${
            language === "TH"
              ? " text-sm-th md:text-base-th  "
              : " text-sm md:text-base  "
          } text-laudry-gray-200 font-semibold leading-6 line-clamp-2`}
        >
          <span className="group-hover:underline break-all">
            {locationData?.terms?.length > 0 &&
              locationData?.terms[0]?.value &&
              locationData?.terms[0]?.value}
          </span>

          <div className={STYLE_SUB_DETAIL(language)}>
            {locationData?.terms?.map((item, index) => {
              if (index > 1) {
                return `, ${item.value}`;
              } else if (index === 1) {
                return `${item.value}`;
              } else {
                return "";
              }
            })}
          </div>
          <span className="group-hover:underline break-all">
            {location?.terms?.length > 0 &&
              location?.terms[0]?.value &&
              location?.terms[0]?.value}
          </span>
          <div className={STYLE_SUB_DETAIL(language)}>
            {location?.terms?.map((item, index) => {
              if (index > 1) {
                return `, ${item.value}`;
              } else if (index === 1) {
                return `${item.value}`;
              } else {
                return "";
              }
            })}
          </div>
        </div> */}
        <div
          className={`${
            language === "TH"
              ? " text-sm-th md:text-base-th "
              : " text-sm md:text-base "
          } text-laudry-gray-200 font-semibold leading-5  w-[90%] `}
        >
          {/* {location?.description} */}
          {location?.terms?.length > 0 ? (
            <span className="group-hover:underline break-all line-clamp-1">
              {location?.terms[0]?.value}
            </span>
          ) : (
            <span className="group-hover:underline break-all">Unknown</span>
          )}
          <div className={STYLE_SUB_DETAIL(language) + " line-clamp-2 "}>
            {location?.terms?.map((item, index) => {
              if (index > 1) {
                return `, ${item.value}`;
              } else if (index === 1) {
                return `${item.value}`;
              } else {
                return "";
              }
            })}
          </div>
        </div>
      </div>
      {user?._id && (
        <Favorite
          location={location}
          setIsStar={setIsStar}
          isStar={isStar}
          setTab={setTab}
          setSelecte={setSelectedLocation}
        />
      )}
      {index > 0 && (
        <div
          ref={lineRef}
          className="absolute -left-6 border-b border-gray-200  w-full "
        />
      )}
    </div>
  );
};

const AddressSearch = ({
  setTab,
  isStar,
  setIsStar,
  history,
  setHistory,
  myAddress,
}) => {
  const navigate = useNavigate();
  const { language } = React.useContext(ContextLanguage);
  // const [search, setSearch] = React.useState("");
  const [locations, setLocations] = React.useState([]);
  const { user } = useSelector((state) => state.auth);

  // React.useEffect(() => {
  //   const loadSearch = sessionStorage.getItem("search");
  //   if (loadSearch) {
  //     setSearch(loadSearch);
  //     setTimeout(() => {
  //       sessionStorage.removeItem("search");
  //     }, 5000);
  //   } else {
  //     return;
  //   }
  // }, []);

  const search = StoreSearch((state) => state.search);
  const setSearch = StoreSearch((state) => state.setSearch);

  const setSelectedLocation = StoreSelectedLocation(
    (state) => state.setSelectedLocation
  );

  const thisSearch = FunctionUseDebounce(search, 600);

  React.useEffect(() => {
    if (thisSearch.length >= 3) {
      AddressFunctionSearchLocation(thisSearch, setLocations);
    } else {
      setLocations([]);
    }
  }, [thisSearch]);

  React.useEffect(() => {
    setIsStar(false);
  }, []);

  return (
    <div className={STYLE_SCREEN_FULL_WITH_FOOTER}>
      <Container>
        <div className={`${STYLE_MAX_WIDTH_DESKTOP} ${STYLE_PADDING_NO_MB}`}>
          <div
            className={`${`bg-white  md:ordershadow px-4 md:px-6 md:pb-0 rounded-xl h-full`}  `}
          >
            <div className={`${STYLE_PROGRAM_BACK(language)} flex  gap-6`}>
              <ICON_CHEVRON_LEFT
                className={`${STYLE_BUTTON_ICON_LEFT} flex-none`}
                onClick={(e) => {
                  const isAdding = sessionStorage.getItem("isAdding");
                  if (isAdding) {
                    sessionStorage.removeItem("isAdding");
                    setTab(STATE_CONSTANTS_ADDRESS.SELECT);
                  } else {
                    const back = sessionStorage.getItem("redirect-back-to");
                    if (back !== "/Address") {
                      navigate(back);
                    } else {
                      navigate("/");
                    }
                    // RouterSetRouteByHistory(
                    //   e,
                    //   setHistory,
                    //   setTab,
                    //   navigate,
                    //   history
                    // );
                  }
                }}
              />
              <div className=" items-center  pr-4 md:pr-0 w-full flex-shrink">
                <FieldSearchLocation
                  icon={<ICON_LOCATION className={STYLE_SEARCH_ADDRESS_ICON} />}
                  value={search}
                  setValue={setSearch}
                  className={STYLE_SEARCH_ADDRESS}
                  classNameParent={STYLE_PARENT_ADDRESS(language)}
                  padding=""
                  placeholder={TEXT_ADDRESS_SEARCH[language]}
                />
              </div>
            </div>
            {locations?.length > 0 ? (
              <div>
                {locations?.map((location, index) => {
                  return (
                    <AddressLocation
                      setTab={setTab}
                      location={location}
                      key={`key-of-location-${index}`}
                      isStar={isStar}
                      setIsStar={setIsStar}
                      setHistory={setHistory}
                      index={index}
                      myAddress={myAddress}
                    />
                  );
                })}
              </div>
            ) : (
              <React.Fragment>
                {user?._id ? (
                  <div className="pb-8">
                    <ICON_EMPTY_ADDRESS className={STYLE_IMG_EMPTY} />
                    <div className={STYLE_TEXT_SMS(language)}>
                      {TEXT_ADDRESS_DATA_NOTFOUND[language]}
                    </div>
                  </div>
                ) : (
                  <AddressEmpty />
                )}
              </React.Fragment>
            )}
          </div>
        </div>
      </Container>
      <BottomBar
        classNameBottomBar={`${STYLE_HEIGHT_BAR}`}
        onClick={() => {
          // RouterGetHistory(setHistory, STATE_CONSTANTS_ADDRESS.SELECT);
          AddressOnClickCurrentLocation(setTab, setSelectedLocation);
        }}
        title={TEXT_CHOOSE_ADDRESS[language]}
        icon="/icons/map.svg"
      />
    </div>
  );
};

export default AddressSearch;
